import React from 'react';

import type { PageProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import { TrialFormAu } from 'stile-au/src/components/common/TrialFormAu';
import styled from 'styled-components';

import lunariaBackground from 'stile-shared/assets/images/lunaria/lunaria_background.svg';
import hearFromTeam from 'stile-shared/assets/videos/hear_from_team.mp4';
import livingMoon from 'stile-shared/assets/videos/living_moon.mp4';

import { Button } from 'stile-shared/src/components/2024/common/Button';
import { Card } from 'stile-shared/src/components/2024/common/Card';
import TitleMenu from 'stile-shared/src/components/2024/common/Included/WITBTitleMenu/WITBTitleMenu';
import Top from 'stile-shared/src/components/2024/common/Included/WITBTopSection/WITBTopSection';
import { StyledWITBTopSection } from 'stile-shared/src/components/2024/common/Included/WITBTopSection/WITBTopSection.styles';
import VideoIcon from 'stile-shared/src/components/2024/common/VideoIcon';
import { VideoPlayer } from 'stile-shared/src/components/2024/common/VideoPlayer';
import { EvidenceSection } from 'stile-shared/src/components/2024/layout/CardSection';
import { Grid } from 'stile-shared/src/components/2024/layout/Grid';
import ReviewsSlider from 'stile-shared/src/components/2024/layout/ReviewsSlider/ReviewsSlider';
import { Section } from 'stile-shared/src/components/2024/layout/Section';

import { PageLayout } from 'templates/2024/PageLayout';

const LunariaOnePageLayout = styled(PageLayout)`
  ul {
    list-style-type: disc;
    padding-inline-start: 23px;
  }
  @media (max-width: 768px) {
    .header-wrapper {
      background-color: #5e60ab !important;
    }
  }
`;

const TitleMenuContainer = styled.div`
  background: var(--Secondary-Indigo, #5e60ab);
  width: 100%;
  display: flex !important;
  flex-direction: column !important;
  padding-bottom: 80px !important;
  p {
    color: white !important;
    max-width: 563px !important;
  }
  h1 {
    color: white !important;

    max-width: 761px;
    align-self: center;
  }

  .content {
    padding-top: 0px !important;
    @media (max-width: 768px) {
      .grid-layout {
        margin-top: 28px !important;
      }
      padding-top: 0px !important;
    }
  }
  .video {
    overflow: visible !important;
    .skeleton.skeleton-video,
    video {
      border-radius: 32px;
    }
    aspect-ratio: 1160/653;
    border-radius: 32px;
    box-shadow: 0px 43px 26px 0px rgba(0, 0, 0, 0.04), 0px 19px 19px 0px rgba(0, 0, 0, 0.06),
      0px 5px 11px 0px rgba(0, 0, 0, 0.07);
    margin: 80px auto 70px;
    @media (max-width: 768px) {
      .skeleton.skeleton-video,
      video {
        border-radius: 16px;
      }
      padding-top: 0px !important;
      border-radius: 16px !important;
      box-shadow: 0px 12.603px 7.621px 0px rgba(0, 0, 0, 0.04),
        0px 5.569px 5.569px 0px rgba(0, 0, 0, 0.06), 0px 1.466px 3.224px 0px rgba(0, 0, 0, 0.07);
      margin: 40px auto 32px;
    }
  }
  @media (max-width: 768px) {
    padding: 0 !important;
    margin: 0 !important;
    > div > div {
      padding-top: 17px !important;
    }
    ${StyledWITBTopSection} {
      padding-top: 0 !important;
    }
  }
`;
const RealClassroomsSection = styled<typeof Section>(Section)`
  background: var(--stile-grey-8) !important;
  .content {
    padding-top: 80px !important;
    @media (max-width: 768px) {
      padding: 0 0 60px !important;
    }
  }
  button {
    margin-top: 32px;
    @media (max-width: 768px) {
      margin-top: 30px;
    }
  }
  .grid-layout {
    margin-top: 0 !important;
  }

  .secondary-left,
  .tertiary-right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    h2 {
      text-align: left !important;
      margin: 0 0 32px 0;
      @media (max-width: 768px) {
        margin-bottom: 20px !important;
      }
    }
  }
  .secondary-left {
    grid-column: 1 / span 5;
  }
  .tertiary-left {
    grid-column: 1 / span 6;
    .gatsby-image-wrapper {
      border-radius: 32px;
      box-shadow: 0px 43px 26px 0px rgba(0, 0, 0, 0.04), 0px 19px 19px 0px rgba(0, 0, 0, 0.06),
        0px 5px 11px 0px rgba(0, 0, 0, 0.07);
    }
  }
  .secondary-right {
    .gatsby-image-wrapper {
      border-radius: 32px;
    }
    grid-column: 7 / span 6;
  }
  .tertiary-right {
    grid-column: 8 / span 5;
  }
  @media (max-width: 768px) {
    .secondary-left,
    .secondary-right,
    .tertiary-left,
    .tertiary-right {
      grid-column: 1 / span 12;
    }
    .tertiary-left {
      grid-row: 2;
      margin-top: 30px;
    }
    .secondary-right {
      padding: 30px 0 60px;
    }
  }
  .guidance {
    p {
      padding-bottom: 12px;
    }
    .tertiary-right div p {
      padding-bottom: 0;
      margin-bottom: 0;
    }
    grid-column: span 12;
  }
`;
const JoinMission = styled<typeof RealClassroomsSection>(RealClassroomsSection)`
  background: linear-gradient(180deg, #5e60ab 0%, #2b2b2b 100%) !important;
  .content {
    padding-top: 50px !important;
    padding-bottom: 15px !important;
    @media (max-width: 768px) {
      padding-top: 90px 0 0 !important;
    }
  }
  h4 {
    padding-bottom: 32px;
    @media (max-width: 768px) {
      padding-bottom: 20px;
    }
  }
`;
const ContentWrapper = styled.div`
  display: flex;
  position: relative;
  padding: 115px 0 0px;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
  background: var(--stile-grey-8);
  color: var(--white);
  .yourClassroom {
    max-width: 566px;
    text-align: start;
    min-height: 1570px;
    h6 {
      align-self: start;
    }
    @media (max-width: 768px) {
      max-width: none;
      min-height: 1090px;
      h2 {
        margin-top: 80px !important;
      }
    }
  }
  .livingMoon {
    margin-bottom: 40px !important;
  }
  button {
    img {
      border-radius: 32px;
    }
  }
  .finalVideo {
    margin: 40px 0 150px;

    @media (max-width: 768px) {
      margin: 24px 0 60px;
    }
  }
  p {
    color: var(--white);
    max-width: 566px;
    button {
      padding: 80px 0 150px;
    }
    padding-bottom: 12px;
    @media (max-width: 768px) {
      max-width: none;
    }
  }
  a {
    margin-bottom: 80px;
  }
  h2 {
    width: 100%;
    margin-bottom: 20px;
    text-align: left;
    max-width: 644px;
  }
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 32px;
    box-shadow: 0px 41.958px 25.37px 0px rgba(0, 0, 0, 0.04),
      0px 18.54px 18.54px 0px rgba(0, 0, 0, 0.06), 0px 4.879px 10.733px 0px rgba(0, 0, 0, 0.07);
  }
  @media (max-width: 768px) {
    padding: 0;
    .overlay {
      border-radius: 20px !important;
    }
    .livingMoon {
      margin-bottom: 0 !important;
    }
  }
  .cards-container {
    max-width: 1160px;
    @media (max-width: 1220px) {
      padding: 0 60px 80px;
    }
    @media (max-width: 768px) {
      width: 100%;
      padding: 40px 25px 0;
    }
    .card {
      display: flex;
      padding: 35px 19px;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      margin-bottom: 80px;
      @media (max-width: 768px) {
        margin-bottom: 32px;
        &:last-child {
          margin-bottom: 60px;
        }
      }
      .description {
        text-align: center;
        gap: 20px;
        @media (max-width: 768px) {
          padding-top: 0 !important;
        }
      }
    }
    color: var(--stile-grey-8);
    p {
      color: var(--stile-grey-8) !important;
    }
  }
`;
const ContentWrapperWithImage = styled(ContentWrapper)`
  position: relative;
  background: var(--stile-grey-8);
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 20%;
    background: linear-gradient(0deg, #212643 0%, #2b2b2b 100%);
    z-index: 0;
    @media (max-width: 768px) {
      height: 50%;
    }
  }
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 80%;
    background-image: url(${lunariaBackground});
    background-position: bottom right;
    background-repeat: no-repeat;
    background-size: auto 100%;
    z-index: 0;
    @media (min-width: 2048px) {
      background-size: cover;
    }
    @media (max-width: 768px) {
      height: 50%;
    }
  }
  > .gradient-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50%;
    background: linear-gradient(180deg, rgba(106, 72, 120, 0) 0%, #2b2b2b 100%);
    z-index: 1;
    pointer-events: none;
    @media (max-width: 768px) {
      height: 160px;
    }
  }
  > * {
    position: relative;
    z-index: 2;
  }
`;

const Header = styled<typeof StyledWITBTopSection>(StyledWITBTopSection)`
  z-index: 1;
  will-change: transform;
  transition: transform 0.2s ease-out;
  position: relative;
  max-width: 1160px;
  padding-top: 35px;
  margin-bottom: 80px;
  .green {
    text-align: center;
    color: var(--stile-green-1);
    @media (max-width: 768px) {
      h6 {
        line-height: 12px !important;
      }
    }
  }

  h2 {
    text-align: center !important;
    @media (max-width: 768px) {
      text-align: left !important;
    }
  }
  @media (max-width: 768px) {
    text-align: left !important;
    transform: none !important;
    position: static;
    padding: 0 25px;
    margin-bottom: 0;

    .green {
      margin-bottom: 24px !important;
    }
  }
`;
const ExamplesSection = styled<typeof EvidenceSection>(EvidenceSection)`
  .content {
    padding-top: 80px !important;
    @media (max-width: 768px) {
      padding-top: 28px !important;
      padding-bottom: 8px !important;
      margin: 0 !important;
    }
  }
  @media (max-width: 768px) {
    padding-bottom: 0px;
    margin: 0 !important;
    width: 100%;
  }
  .examples {
    grid-column: 1 / span 12;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(1, 1fr);
    padding: 0 0 32px 0;
    gap: 12px 13px;
    @media (max-width: 1024px) {
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(2, 1fr);
      gap: 12px 13px;
    }
    @media (max-width: 768px) {
      grid-template-columns: repeat(1, 1fr);
    }

  .exampleCard {
    padding: 15px;
    gap: 15px;
    display: flex;
    max-width: 280px;
    flex-direction: column;
    align-items: flex-start;
    text-align: start;
    border-radius: 12px;
    border: 1px solid var(--stile-grey-3);
    background: #5E60AB;
    div {
      display: flex;
      flex-direction: column;
      gap: 4px;
      justify-content: center;
    }
    h6 {
      margin: 0;
    }
    .gatsby-image-wrapper {
      max-width: 50px;
      aspect-ratio: 1;
    }
    @media (max-width: 1024px) {
      max-width: none;
      align-self: stretch;
      width: 100%;
    }
  }
`;

const LeadFormSection = styled<typeof Section>(Section)`
  .column {
    grid-column: span 6;
    h2 {
      text-align: start !important;
    }
  }
  p {
    padding-bottom: 12px;
    max-width: 465px;
  }
  padding-bottom: 150px;
  @media (max-width: 768px) {
    padding-bottom: 60px;
    .column {
      grid-column: span 12;
    }
    p {
      max-width: none;
    }
    .content {
      padding-top: 0 !important;
    }
    h1 {
      margin-top: 12px !important;
    }
  }
`;

function LunariaOnePage(props: PageProps) {
  const [submissionSuccess, setSubmissionSuccess] = React.useState(false);

  const onSubmissionSuccess = () => {
    setSubmissionSuccess(true);
  };
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();

    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  return (
    <LunariaOnePageLayout {...props}>
      <TitleMenuContainer>
        <div className="content">
          <TitleMenu>
            <Top
              title="Can your students help us grow plants on the Moon?"
              description="In 2026, Australia will send its first living biology experiment to the Moon. Your Year 7-10 students can help decide which plants make the journey."
            />
          </TitleMenu>
        </div>
      </TitleMenuContainer>
      <JoinMission textColor="--white">
        <Grid className="guidance">
          <div className="secondary-left">
            <h4>Join the national Moon mission</h4>
            <p>
              Welcome to <strong>Plants - Lunar Edition</strong>: a curriculum-aligned science unit
              and citizen science project. Students will investigate plant biology, engineer lunar
              landing systems, and contribute real data to help scientists decide which seeds will
              be sent to the lunar surface as part of the Australian Lunar Experiment Promoting
              Horticulture (ALEPH) mission.
              <br />
              <Button
                label="Join the mission"
                newTab={false}
                onClick={() => {
                  const element = document.getElementById('lead-form');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
              />
            </p>
          </div>
          <div className="secondary-right">
            <StaticImage
              src="../../../../stile-shared/assets/images/lunaria/moon_mission.jpg"
              alt="Workshops & events"
            />
          </div>
        </Grid>
      </JoinMission>
      <ContentWrapper>
        <Header className="livingMoon">
          <h2>A living Moon experiment</h2>
          <p>
            In early 2026, ALEPH will send a payload to a Moon-bound lander to test whether plants
            can survive and grow in lunar conditions. The seeds must survive intense G-forces during
            launch, the deep freeze of space travel and the hostile lunar surface—no air, no water,
            no pollinators.
          </p>
          <p>
            To prepare, Lunaria One is enlisting Australian students to run the experiment
            Earth-side. Not only will they be learning plant biology, they'll be testing
            sustainability strategies and contributing real data to help decide which seeds are sent
            to the Moon.
          </p>
          <p>
            Your students take on the challenge, bringing together biological science, data
            analysis, and engineering design. The classroom becomes a launchpad: part lab, part
            engineering studio, part mission control as they:
          </p>
          <ExamplesSection backgroundColor="--stile-grey-8">
            <div className="examples">
              <div className="exampleCard">
                <StaticImage
                  src="../../../../stile-shared/assets/images/lunaria/test.png"
                  alt="Test seed resilience"
                />
                <div>
                  <h6>Test seed resilience</h6>
                  <span>to heat, cold, drought and darkness</span>
                </div>
              </div>
              <div className="exampleCard">
                <StaticImage
                  src="../../../../stile-shared/assets/images/lunaria/examine.png"
                  alt="Examine frozen cells"
                />
                <div>
                  <h6>Examine frozen cells</h6>
                  <span>of various plants under the microscope</span>
                </div>
              </div>
              <div className="exampleCard">
                <StaticImage
                  src="../../../../stile-shared/assets/images/lunaria/build.png"
                  alt="Build a Lunarium"
                />
                <div>
                  <h6>Build a Lunarium</h6>
                  <span>a protective, self-watering landing device</span>
                </div>
              </div>
              <div className="exampleCard">
                <StaticImage
                  src="../../../../stile-shared/assets/images/lunaria/contribute.png"
                  alt="Contribute data"
                />
                <div>
                  <h6>Contribute data</h6>
                  <span>to a national citizen science portal, shared with Lunaria One</span>
                </div>
              </div>
            </div>
          </ExamplesSection>
          <h6 className="green">
            Every result contributes to a real scientific decision:
            <br />
            Which seeds will travel to the Moon?
          </h6>
        </Header>
        <div className="content">
          <VideoIcon
            style="secondary"
            image={
              <>
                <VideoPlayer url={livingMoon} />

                <div className="overlay" />
              </>
            }
            youtubeUrl="https://www.youtube.com/watch?v=Kc6Qz7wDPuw"
          />
        </div>
      </ContentWrapper>
      <ContentWrapperWithImage>
        <div className="gradient-overlay" />
        <Header className="yourClassroom">
          <h2>What will happen in your classroom</h2>
          <h6>Turn Lunaria One's 2026 mission into a powerful Depth Study.</h6>
          <p>
            Give your students the chance to contribute to a real lunar mission, backed by the
            Australian Space Agency and supported by NASA’s Artemis Accords.
          </p>
          <p>
            With Plants - Lunar Edition, you’ll embark upon a rigorous, hands-on science unit that
            blends biology, engineering and data science.
          </p>
          <h6>Sign up and get access to:</h6>
          <ul>
            <li>A complete, ready-to-teach unit, perfectly aligned to Year 8 biology content</li>
            <li>Customisable lessons, practical activities and assessments</li>
            <li>A classroom-tested data collection platform</li>
            <li>A national citizen science project linked to Lunaria One's 2026 Moon mission</li>
          </ul>
        </Header>
      </ContentWrapperWithImage>
      <RealClassroomsSection textColor="--white" backgroundColor="--stile-green-2">
        <Grid className="guidance">
          <div className="tertiary-left">
            <StaticImage
              src="../../../../stile-shared/assets/images/lunaria/ready_to_teach.jpg"
              alt="Workshops & events"
            />
          </div>
          <div className="tertiary-right">
            <h2>Everything you need, ready to teach</h2>
            <p>
              This unit is designed to help you deliver rigorous, engaging science with minimal
              prep.
            </p>
            <div>
              <p>What’s included:</p>
              <ul>
                <li>Lesson plans, teaching notes and assessments</li>
                <li> Student workbooks, lab guides and videos </li>
                <li>Hands-on experiments and pre-prepared risk assessments </li>
                <li>Built-in tools for class-wide data analysis</li>
              </ul>
            </div>
          </div>
        </Grid>
      </RealClassroomsSection>
      <ContentWrapper>
        <Header>
          <h2>Meet the experts behind the mission</h2>
          <p>
            At the heart of the ALEPH mission are three remarkable women. Bringing together their
            interdisciplinary expertise, they’ve worked closely with Stile to bring the journey
            behind the lessons to life.
          </p>
          <p>
            Their voices and insights will guide the journey, giving students a real connection to
            the people behind the mission.
          </p>
        </Header>
        <Grid className="cards-container">
          <Card
            backgroundColor="--white"
            headerImage={
              <StaticImage
                src="../../../../stile-shared/assets/images/lunaria/lauren_fell.jpg"
                alt="Workshops & events"
              />
            }
            description={
              <>
                <div>
                  <h4>Lauren Fell</h4>
                  <h6 className="h8">
                    Director,
                    {!isMobile && <br />}
                    Lunaria One
                  </h6>
                </div>

                <p>
                  “This mission is about more than science—it’s about inspiring the next generation
                  of space researchers.”
                </p>
              </>
            }
          />

          <Card
            backgroundColor="--white"
            headerImage={
              <StaticImage
                src="../../../../stile-shared/assets/images/lunaria/tien_hunyh.jpg"
                alt="Workshops & events"
              />
            }
            description={
              <>
                <div>
                  <h4>Dr Tien Hunyh</h4>
                  <h6 className="h8">
                    Plant Biologist,
                    {!isMobile && <br />}
                    RMIT
                  </h6>
                </div>
                <p>
                  “Understanding plant resilience in space will help unlock future food sources
                  beyond Earth.”
                </p>
              </>
            }
          />

          <Card
            backgroundColor="--white"
            headerImage={
              <StaticImage
                src="../../../../stile-shared/assets/images/lunaria/siena_zubcic.jpg"
                alt="Workshops & events"
              />
            }
            description={
              <>
                <div>
                  <h4>Siena Zubcic</h4>
                  <h6 className="h8">
                    Mechanical Systems Engineer,
                    {!isMobile && <br />}
                    Lunar Outpost Oceania
                  </h6>
                </div>
                <p>
                  “We’re designing the systems that will allow plants to grow in one of the harshest
                  environments—space.”
                </p>
              </>
            }
          />
        </Grid>
        <h6>Hear from the team making it happen</h6>
        <div className="content">
          <div className="finalVideo">
            <VideoIcon
              style="secondary"
              image={
                <>
                  <VideoPlayer url={hearFromTeam} />

                  <div className="overlay" />
                </>
              }
              youtubeUrl="https://www.youtube.com/watch?v=7bcfUQs7PV0"
            />
          </div>
        </div>
      </ContentWrapper>
      <ReviewsSlider header="What educators are saying" />
      <LeadFormSection id="lead-form">
        <div className="column">
          <div>
            <h2>Bring the mission to your classroom</h2>
          </div>
          <p>
            This unit is created for <strong>Year 7-10 students.</strong>
          </p>
          <p>
            Sign up for free access to Stile’s <strong>Plants - Lunar Edition</strong>.
          </p>
          <p>We'll get you set up and ready to get started.</p>
          <p>The countdown to launch starts now.</p>
        </div>

        {!submissionSuccess && (
          <div className="column">
            <TrialFormAu
              onSubmissionSuccess={onSubmissionSuccess}
              leadType="LUNARIA_ONE"
              submitLabel="Join the mission today"
            />
          </div>
        )}

        {submissionSuccess && (
          <div className="column">
            <p>Thank you for completing this form. We will be in touch shortly.</p>
          </div>
        )}
      </LeadFormSection>
    </LunariaOnePageLayout>
  );
}

export default LunariaOnePage;
